import React from "react";
import { FaPen } from "react-icons/fa";
import { MdDelete, MdFastfood } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { deleteNourriture, getOneNourr } from "../JS/actions/nourritures";

const Nourriture = ({ nourriture }) => {
  const user = useSelector((state) => state.memberReducers.member);

  const dispatch = useDispatch();
  const handleDelete = () => {
    const result = window.confirm("are you sure");
    if (result) {
      dispatch(deleteNourriture(nourriture._id));
    }
  };
  const handleNourr = () => {
    dispatch(getOneNourr(nourriture._id));
  };
  return (
    <div class="main-container">
      <div class="heading">
        {/* <h1 class="heading__title">Stock Nourritures</h1> */}
      </div>
      <div class="cardss">
        <div class="cardd card-4">
          <div class="card__icon">
            <b> {nourriture.title} </b>
            <MdFastfood style={{ fontSize: "30px", color: "orange" }} />{" "}
          </div>
          <p class="card__exit">
            {/* <i class="fas fa-times"></i> */} Quantity : {nourriture.qte}
          </p>
          <p class="card__title">{nourriture.description}</p>
          <p class="card__apply">
            {user.role == "admin" ? (
              <a onClick={handleDelete} class="card__link" href="#">
                Delete{" "}
                <MdDelete
                  onClick={handleDelete}
                  style={{ color: "red", fontSize: "22px" }}
                />{" "}
              </a>
            ) : user.role == "logistique" ? (
              <a onClick={handleDelete} class="card__link" href="#">
                Delete{" "}
                <MdDelete
                  onClick={handleDelete}
                  style={{ color: "red", fontSize: "22px" }}
                />{" "}
              </a>
            ) : null}{" "}
            {user.role == "admin" ? (
              <Link to={`/editNourritures/${nourriture._id}`}>
                <a onClick={handleNourr} class="card__link">
                  Update{" "}
                  <FaPen
                    // onClick={handleEvent}
                    style={{ color: "green", fontSize: "18px" }}
                  />
                </a>
              </Link>
            ) : user.role == "logistique" ? (
              <Link to={`/editNourritures/${nourriture._id}`}>
                <a onClick={handleNourr} class="card__link">
                  Update{" "}
                  <FaPen
                    // onClick={handleEvent}
                    style={{ color: "green", fontSize: "18px" }}
                  />
                </a>
              </Link>
            ) : null}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Nourriture;
